import { HTMLAttributes } from "react"
import { styled, StyleProps } from "../styles"
import { flexCss } from "../Flex"

export type Status = "accept" | "reject"
type DivProps = HTMLAttributes<HTMLDivElement>

export const UploadWrapper = styled.div<DivProps>((props: StyleProps) => ({
  ...flexCss,
  width: `100%`,
  marginBottom: props.theme.spacing(4),
  flexDirection: `column`,
}))

type DragContainerProps = {
  status: Status
}

type DragContainerStyleProps = DragContainerProps & StyleProps

const getDragContainerBorderColor = (props: DragContainerStyleProps) => {
  if (props.status === `accept`) return props.theme.palette.valid
  if (props.status === `reject`) return props.theme.palette.error
  return props.theme.palette.coal.dark
}

export const DragContainer = styled.div<DragContainerProps & DivProps>((props: DragContainerStyleProps) => ({
  width: `100%`,
  height: `100%`,
  padding: props.theme.spacing(4),
  border: `1px dashed ${getDragContainerBorderColor(props)}`,
  borderRadius: props.theme.borderRadius.sm,
  cursor: `pointer`,
  marginBottom: props.theme.spacing(4),
}))
